<style lang="less" rel="stylesheet/stylus" scoped>
.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  font-size: 16px;
  .show-box {
    width: 600px;
    border-radius: 15px;
    text-align: center;
    background: #ffffff;
    // animation: alertAnimate .4s cubic-bezier(0.645, 0.045, 0.150, 1);
    p {
      margin: 0 auto;
      display: flex;
      justify-content: center;
      -webkit-align-items: center;
      align-items: center;
    }
    .twoLine-box {
      padding: 50px 45px;
      //width: 436px;
      box-sizing: border-box;

      .network {
        font-size: 28px;
        color: #004466;
        line-height: 36px;
      }
      .error-number {
        font-size: 22px;
        color: #003057;
        line-height: 18px;
        margin-top: 26px;
      }
    }
    .btn-box {
      display: flex;
      flex-direction: row;
      height: 80px;
      border-top: 1px solid #9ebfc8;
      div {
        flex: 1;
        box-sizing: border-box;
        font-size: 24px;
        color: #0073ae;
        line-height: 80px;
        &.disabled {
          color: #999999;
          &:hover {
            color: #999999;
          }
        }
        &:hover {
          color: #66b8e2;
        }
      }
      div:nth-child(2) {
        box-sizing: border-box;
        border-left: 1px solid #9ebfc8;
        line-height: 80px;
      }
    }
  }
  .int {
    width: 100%;
    border: 0;
    border-bottom: 1px solid #9ebfc8;
    outline: 0;
    font-size: 14px;
    color: #004466;
    padding: 10px 0;
    height: 46px;
    background: transparent;
    transition: border-color 0.2s;
  }
  .int::-webkit-input-placeholder {
    color: #004466;
    line-height: 36px;
    font-size: 20px;
  }
  .int {
    -webkit-text-fill-color: #004466;
  }
  p.u-note {
    width: 400px;
    margin-top: 5px;
    justify-content: start;
    color: #004466;
  }
}

.zoomIn-enter-active,
.zoomIn-enter {
  animation: zoomIn 0.4s cubic-bezier(0.645, 0.045, 0.15, 1);
}
.zoomIn-leave-active, .zoomIn-leave-to /* .fade-leave-active below version 2.1.8 */ {
  animation: zoomIn 0.4s reverse cubic-bezier(0.645, 0.045, 0.15, 1);
}
</style>
<template>
  <transition name="zoomIn">
    <div class="mask" v-show="show">
      <div class="show-box">
        <!-- 两个行文本样式一样或者不一样的的都可以用这个 -->
        <div class="twoLine-box">
          <!--          <p class="error-number" v-show="isErr">新密码不能与初始密码相同</p>-->
          <p class="network" :style="{ fontSize: size + 'px' }">
            初始密码即将失效，请设置新密码
          </p>
          <p style="width: 400px; margin-top: 20px">
            <input
              type="password"
              placeholder="4位数字新密码"
              class="int"
              maxlength="4"
              v-model="password"
            />
          </p>
          <p class="u-note" style="color: red">*新密码不能与初始密码相同</p>
        </div>
        <!-- 按钮 -->
        <div class="btn-box">
          <div
            :class="[
              'chongshu',
              canSet ? '' : 'disabled',
              canSet ? 'cursor' : '',
            ]"
            @click="canSet ? setPwd(password) : ''"
          >
            确定
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/*
	2、show:父组件传递fasle,true来控制盒子组件的显示隐藏（默认为显示）
	3、按钮功能
	      文字描述  事件对应字段 文案对应字段
	左边   取消（）  cancelEvent    cancle

	右边    确定       ensure         btn

	4、sameOne：加粗大的字
	   sameTwo：加粗大的字
	   errorNum：为小的不加粗的字
	 */
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      isErr: false,
      password: '',
    };
  },
  props: {
    phone: {
      type: String,
      default: '',
    },
    show: {
      type: [Boolean, Number],
      default: false,
    },
    btn: {
      type: String,
      default: '',
    },
    cancal: {
      type: String,
      default: '',
    },
    //粗体大字
    sameOne: {
      type: String,
      default: '',
    },
    //粗体大字
    sameTwo: {
      type: String,
      default: '',
    },
    //错误代码字段
    errorNum: {
      type: [Number, String],
      default: null,
    },
    //错误提示
    errorAlert: {
      type: String,
      default: '',
    },
    //字体大小
    size: {
      type: Number,
    },
  },
  created() {},
  computed: {
    canSet() {
      return (
        this.password !== this.phone.slice(-4) && this.password.length === 4
      );
    },
  },
  methods: {
    ...mapActions(['resetPwdNoVc']),
    //=>取消事件
    cancelE() {
      this.$emit('update:show', false);
    },
    async setPwd(pwd) {
      if (pwd === this.phone.slice(-4) || pwd.length < 4) {
        this.isErr = true;
        return;
      }

      let { res, ok } = await this.resetPwdNoVc({
        phonenum: this.phone.replace(/\s/g, ''),
        usertype: 'student',
        password: pwd,
      });
      if (ok) {
        // this.showSetTip(ok);
        // this.loginIn(this.phone);
        this.$emit('update:show', false);
        this.$emit('login', pwd);
      }
    },
    //确定事件
    defaultAlert() {
      this.$emit('ensure');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/basic/updPwd.vue